import { IconButton, PixelPlaceholderLoader } from "@similarweb/ui-components";

import { alertsTracking } from "app/pages/digital-marketing/monitor-and-protect/services/tracking/alerts";
import { useTranslation } from "pro-features/components/WithTranslation";

interface IAlertsModalButtonProps {
    isError: boolean;
    isLoading: boolean;
    isSubscribed: boolean;
    onClick: () => void;
}

export const AlertsModalButton = ({ isError, isLoading, isSubscribed, onClick }: IAlertsModalButtonProps) => {
    const translate = useTranslation();

    if (isError) {
        return null;
    }

    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                height="40px"
                width="200px"
            />
        );
    }

    const handleClick = () => {
        if (isSubscribed) {
            alertsTracking.onUnsubscribeButtonClick();
        } else {
            alertsTracking.onSubscribeButtonClick();
        }
        onClick();
    };

    return (
        <IconButton
            type="outlined"
            iconName={isSubscribed ? "alerts_off" : "alerts"}
            onClick={handleClick}
        >
            {isSubscribed
                ? translate("monitor_and_protect.shared.alerts_modal.unsubscribe_button")
                : translate("monitor_and_protect.shared.alerts_modal.subscribe_button")}
        </IconButton>
    );
};
